module.exports = __webpack_public_path__ + "static/001overlay-95d11469affb77c403ad93a34a775386.png";